import { Fragment } from 'react'
import { useFieldArray, useFormContext } from 'react-hook-form'
import { Add, Close } from '@mui/icons-material'
import {
  Button,
  FormControl,
  FormLabel,
  IconButton,
  Stack,
  Typography,
} from '@mui/material'
import Grid from '@mui/material/Grid2'
import { FormTextField } from '@/components/forms'
import { PropertyFieldProps } from './PropertyField'

type PropertyMultiTextFieldProps = PropertyFieldProps

export default function PropertyMultiTextField({
  propertyId,
  property,
  required,
}: PropertyMultiTextFieldProps) {
  const { fields, append, remove } = useFieldArray({
    name: propertyId,
    rules: { required },
  })
  const { label, description } = property.display
  const { register } = useFormContext()

  return (
    <FormControl sx={{ rowGap: 1 }}>
      <Stack>
        {label && <FormLabel>{label}</FormLabel>}
        {description && (
          <Typography variant="caption" color="text.secondary">
            {description}
          </Typography>
        )}
      </Stack>

      <Button
        onClick={() => append({ value: '' })}
        startIcon={<Add />}
        sx={{
          width: 'fit-content',
        }}
        variant="text"
      >
        Add
      </Button>
      <Grid container rowSpacing={1} columnSpacing={0.5} alignItems="center">
        {fields.map((field, index) => {
          return (
            <Fragment key={field.id}>
              <Grid size={11}>
                <FormTextField
                  required={required}
                  variant="outlined"
                  fullWidth
                  {...register(`${propertyId}.${index}.value`, {
                    validate: (value) => value.trim().length > 0,
                  })}
                />
              </Grid>
              <Grid size={1}>
                <IconButton onClick={() => remove(index)} size="small">
                  <Close fontSize="inherit" />
                </IconButton>
              </Grid>
            </Fragment>
          )
        })}
      </Grid>
    </FormControl>
  )
}
